
div
  chart(
    v-bind="$attrs"
    v-on="$listeners"
    :type="type",
    :params="params",
    :options="options",
    :benchmark-options="benchmarkOptions",
    :extrapolate-enabled='extrapolate',
    :benchmark-open="benchmarkOpen || false",
    :benchmark-enabled="benchmarkEnabled",
    :public="public",
    :height="650"
  )
